import { usingGet, usingPost } from '@ocean/api'
import { UserUtils } from 'utils'

export const getEventDetails = (eventId: Guid) =>
  usingGet(`virtualevents/event/${eventId}/schedule/list`, { useProxy: true })

export const joinWaitlist = (eventId: Guid, scheduleId?: Guid) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingPost('virtualevents/JoinVirtualEventWaitList', { eventId, scheduleId, userId })
}

export const leaveWaitlist = (eventId: Guid, scheduleId?: Guid) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingPost('virtualevents/LeaveVirtualEventWaitList', { eventId, scheduleId, userId })
}

export const bookEvent = (scheduleId: Guid) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingPost('virtualevents/JoinVirtualEventSchedule', { scheduleId, userId })
}

export const cancelBooking = (scheduleId: Guid) => {
  const { login: userId } = UserUtils.getUserAccountInfo()
  return usingPost('virtualevents/LeaveVirtualEventSchedule', { scheduleId, userId })
}
